import { Box, Typography } from "@mui/material"
import React from "react"

export function PatchNote3_2(): React.JSX.Element {
  return (
    <>
      <Typography variant="body1" gutterBottom>
        🎉 Les nouveautés de la{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          version 3.2
        </Box>
      </Typography>

      <Typography variant="body2" sx={{ mb: 1 }}>
        • Possibilité de{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          modifier la morphologie d’un bâtiment par groupe de niveaux
        </Box>{" "}
        (par exemple, dans le cas d’un attique ou d’un bâtiment avec retraits).
      </Typography>

      <Typography variant="body2" sx={{ mb: 1 }}>
        • Il est désormais possible de{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          filtrer les graphiques des résultats depuis la maquette beem
        </Box>{" "}
        (en double cliquant sur un des éléments).
      </Typography>
    </>
  )
}
